import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowDown,
  faArrowLeft,
  faCartArrowDown,
  faCartShopping,
  faExternalLink,
  faFlag,
  faHeart,
  faMicrophoneAlt,
  faMicrophoneAltSlash,
  faPhone,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faStop,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCircleXmark as farCircleXmark,
  faHeart as farHeart,
} from "@fortawesome/free-regular-svg-icons";
import {
  faApplePay as fabApplePay,
  faCcAmazonPay as fabCcAmazonPay,
  faCcAmex as fabCcAmex,
  faCcApplePay as fabCcApplePay,
  faCcDinersClub as fabCcDinersClub,
  faCcDiscover as fabCcDiscover,
  faCcJcb as fabCcJcb,
  faCcMastercard as fabCcMastercard,
  faCcPaypal as fabCcPaypal,
  faCcVisa as fabCcVisa,
  faGooglePay as fabGooglePay,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faArrowDown,
  faArrowLeft,
  faCartArrowDown,
  faCartShopping,
  faExternalLink,
  faFlag,
  faHeart,
  faMicrophoneAlt,
  faMicrophoneAltSlash,
  faPhone,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faStop,
  faUser
);

library.add(farCircleXmark, farHeart);

library.add(
  fabApplePay,
  fabCcAmazonPay,
  fabCcAmex,
  fabCcApplePay,
  fabCcDinersClub,
  fabCcDiscover,
  fabCcJcb,
  fabCcMastercard,
  fabCcPaypal,
  fabCcVisa,
  fabGooglePay
);

export default FontAwesomeIcon;
